import React, {useEffect} from "react";
import { withRouter } from "react-router-dom";
import TamaraReturnBase from "./TamaraReturnBase";
import { Api } from "../../api";

const TamaraCancel = (props) => {
   const searchParams = new URLSearchParams(props.location.search);
  const paymentId = searchParams.get("payment_id");

 useEffect(() => {
  if (paymentId) {
    Api.cart.retrieveTabbyPayment(paymentId)
      .then(response => {
        console.log("Tabby Payment Info:", response);
        // handle status, message, etc.
      })
      .catch(err => {
        console.error("Failed to fetch Tabby payment:", err);
      });
  }
}, [paymentId]);
  return (
    <TamaraReturnBase
      iconClass="fa-info-circle text-warning"
      title="تم إلغاء الدفع"
      message="لقد ألغيت الدفعة. فضلاً حاول مجددًا أو اختر طريقة دفع أخرى"
      buttonText="إعادة المحاولة"
      buttonAction={() => props.history.push("/cart")}
    />
  );
};

export default withRouter(TamaraCancel);
